import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const Ctx = createContext({ colours: [], reload: () => {} });

export const ColoursProvider = ({ children }) => {
  const [colours, setColours] = useState([]);
  const { user } = useAuth();

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/colours");
      setColours(data || []);
    } catch (e) {
      console.warn("Colours load failed:", e);
    }
  }, []);

  useEffect(() => {
    if (user) reload();
  }, [user, reload]);

  const value = useMemo(
    () => ({
      colours,
      names: colours.map((c) => c.name),
      swatchOf: (name) => colours.find((c) => c.name === name)?.swatch || null,
      swatchImageOf: (name) =>
        colours.find((c) => c.name === name)?.swatch_image || null,
      reload,
    }),
    [colours, reload],
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useColours = () => useContext(Ctx);
